import React from "react";
import dayjs from "dayjs";
import { Edit } from "@refinedev/antd";
import { useCustom, useCustomMutation } from "@refinedev/core";
import { message, Form } from "antd";
import {
  PURCHASE_REQUEST_ONE_QUERY,
  UPDATE_PURCHASE_REQUEST_MUTATION,
  SUBMIT_PURCHASE_REQUEST_MUTATION,
} from "./queries";
import { PurchaseRequestForm } from "./components/PurchaseRequestForm";
import { useParams } from "react-router-dom";

export const EditPurchaseRequest: React.FC = () => {
  const params = useParams();
  const id = params?.id as string;

  const [form] = Form.useForm();

  // Fetch one PR
  const { data, isLoading, refetch } = useCustom<any>({
    url: "",
    method: "post",
    meta: {
      gqlQuery: PURCHASE_REQUEST_ONE_QUERY,
      variables: { id },
    },
    queryOptions: { enabled: !!id },
  });

  const record = (data as any)?.data?.purchaseRequest ?? (data as any)?.data ?? undefined;

  // Update draft
  const { mutate: updateMutate, isLoading: updating } = useCustomMutation();
  // Submit (existing request path)
  const { mutate: submitMutate, isLoading: submitting } = useCustomMutation();

  const onSaveDraft = async (values: any) => {
    if (!id) return;
    updateMutate(
      {
        url: "",
        method: "post",
        values: {
          id,
          input: values,
        },
        meta: { gqlMutation: UPDATE_PURCHASE_REQUEST_MUTATION },
      },
      {
        onSuccess: () => {
          message.success("Purchase Request updated");
          refetch();
        },
        onError: (e) => {
          console.error(e);
          message.error("Failed to update request");
        },
      },
    );
  };

  const onSubmit = async (payload: { fiscalYear: number }) => {
    if (!id) return;
    submitMutate(
      {
        url: "",
        method: "post",
        values: {
          input: {
            requestId: id,
            fiscalYear: Number(payload.fiscalYear),
          },
        },
        meta: { gqlMutation: SUBMIT_PURCHASE_REQUEST_MUTATION },
      },
      {
        onSuccess: () => {
          message.success("Purchase Request submitted");
          refetch();
        },
        onError: (e) => {
          console.error(e);
          message.error("Failed to submit request");
        },
      },
    );
  };

  return (
    <Edit
      title="Edit Purchase Request"
      isLoading={isLoading}
      saveButtonProps={{ loading: updating || submitting, style: { display: "none" } }}
      footerButtons={() => null}
    >
      <PurchaseRequestForm
        form={form}
        isEdit
        requestId={id}
        initialValues={{
          title: record?.title,
          description: record?.description,
          isUnplanned: record?.isUnplanned,
          teamId: record?.teamId,
          templateId: record?.templateId,
          dateRequested: record?.dateRequested ? dayjs(record.dateRequested) : undefined,
          dateRequired: record?.dateRequired ? dayjs(record.dateRequired) : undefined,
          requestedBy: record?.requestedBy,
          budgetSource: record?.budgetSource,
          budgetId: record?.budgetId,
          tags: record?.tags,
          notes: record?.notes,
          fiscalYear: new Date().getFullYear(), // user picks for submission
          items: record?.items,
          attachments: record?.attachments, // Pass attachments as initial form value
        }}
        onSaveDraft={onSaveDraft}
        onSubmit={onSubmit as any}
      />
    </Edit>
  );
};